export const MOTIVATIONAL_MESSAGES = [
  'Nem todo dia você estará motivado. É por isso que existe a disciplina.',
  'Você não precisa vencer o concurso hoje. Precisa vencer o estudo de hoje.',
  'Talvez a chegada ainda não esteja visível. Continue caminhando.',
  'Deus conhece o caminho inteiro. A você cabe continuar dando o próximo passo.',
  'Algumas páginas lidas são melhores que mais um dia adiado.',
  'Constância é continuar mesmo quando o resultado ainda não apareceu.',
  'O estudo silencioso de hoje prepara a conquista que amanhã será pública.',
  'Disciplina é cumprir o combinado que você fez consigo mesmo.',
  'Um ritmo sustentável leva mais longe que uma pressa impossível de manter.',
  'A dúvida diminui quando você volta ao trabalho.',
  'Não confunda cansaço com incapacidade. Descanse e prossiga.',
  'Cada questão corrigida transforma uma falha em direção.',
  'Seu progresso também acontece nos dias em que parece pequeno.',
  'A aprovação começa muito antes do resultado: começa na rotina.',
  'Faça com atenção o que cabe neste dia.',
  'A paciência não paralisa; ela sustenta o esforço pelo tempo necessário.',
  'Recomeçar hoje ainda é avançar.',
  'O conteúdo difícil se torna familiar para quem permanece.',
  'Não espere facilidade para reconhecer que está evoluindo.',
  'A fé não elimina o caminho; oferece força para percorrê-lo.',
  'Seu futuro agradece a hora de estudo que ninguém vê.',
  'A consistência protege seus planos das oscilações do humor.',
  'O erro bem analisado pode ensinar mais que um acerto por acaso.',
  'Quem revisa com humildade aprende com profundidade.',
  'Hoje pode ser apenas mais um dia; faça dele mais um passo.',
  'Você não controla a concorrência. Controle sua preparação.',
  'O sacrifício só faz sentido quando serve a um propósito claro.',
  'Continue construindo mesmo antes de receber qualquer aplauso.',
  'A matéria não precisa parecer fácil; precisa ser enfrentada com método.',
  'Pequenos compromissos cumpridos formam uma confiança verdadeira.',
  'Não negocie com a tarefa que você já decidiu que importa.',
  'A esperança amadurece quando caminha ao lado da responsabilidade.',
  'Um dia ruim não apaga uma trajetória consistente.',
  'Volte ao plano sem gastar energia punindo o atraso.',
  'Seu motivo precisa ser maior que a desculpa confortável de hoje.',
  'O tempo passará de qualquer forma. Use uma parte dele para se preparar.',
  'A concentração de agora evita o arrependimento depois.',
  'Estudar é aceitar que a clareza costuma chegar depois da insistência.',
  'Nem todo avanço produz euforia; muitos produzem apenas maturidade.',
  'Há força em fazer o básico com regularidade.',
  'O edital é extenso, mas a próxima tarefa é sempre finita.',
  'Comece pela primeira página, não pelo peso do livro inteiro.',
  'O que hoje exige esforço amanhã pode se tornar domínio.',
  'Preserve sua energia para o que realmente muda seu resultado.',
  'Descanso responsável também faz parte de uma preparação séria.',
  'A comparação dispersa; o acompanhamento do próprio progresso orienta.',
  'Você pode sentir medo e ainda assim manter o compromisso.',
  'A coragem do concurseiro aparece na repetição dos dias comuns.',
  'Sua meta merece uma rotina, não apenas uma torcida.',
  'Quando faltar ânimo, reduza o passo sem abandonar a direção.',
  'A revisão de hoje é respeito pelo esforço que você já fez.',
  'Aprender leva tempo; desistir não acelera esse processo.',
  'Confie menos na vontade momentânea e mais no horário estabelecido.',
  'Nenhuma questão difícil define sua capacidade inteira.',
  'Corrigir-se sem se diminuir é uma habilidade de quem evolui.',
  'O resultado é futuro; a preparação acontece no presente.',
  'Se hoje couber pouco, faça pouco com inteira presença.',
  'A aprovação exige conhecimento, mas também exige permanência.',
  'Você não está atrasado enquanto continua avançando com honestidade.',
  'A pressa pede atalhos; a preparação sólida pede fundamentos.',
  'Há dias de colher e há muitos dias de cultivar.',
  'Sua disciplina pode ser discreta e ainda assim transformar sua vida.',
  'A repetição consciente transforma informação em conhecimento.',
  'Não faça do perfeccionismo uma forma elegante de adiar.',
  'Termine a sessão de hoje antes de julgar toda a jornada.',
  'A prova cobrará preparo, não as dificuldades que você precisou superar.',
  'Que sua fé produza serenidade e sua serenidade produza trabalho.',
  'Persistência não é nunca cansar; é saber voltar.',
  'O plano pode mudar sem que o propósito seja abandonado.',
  'Faça perguntas ao conteúdo até que ele deixe de ser estranho.',
  'Cada acerto consciente tem uma história de prática por trás.',
  'O silêncio do estudo também é uma forma de esperança.',
  'Sua rotina atual está escrevendo possibilidades futuras.',
  'Não espere uma semana perfeita para cumprir uma hora possível.',
  'A estabilidade que você busca começa na firmeza das escolhas atuais.',
  'O conhecimento cresce quando você aceita revê-lo quantas vezes for preciso.',
  'Tenha ambição no propósito e humildade no processo.',
  'O caminho longo fica possível quando é dividido em tarefas honestas.',
  'Hoje, faça o que aproxima. Amanhã, faça novamente.',
  'Sua aprovação não precisa de pressa desordenada; precisa de continuidade.',
  'O estudo maduro inclui limites, descanso e retorno.',
  'Não transforme um tropeço em autorização para parar.',
  'A disciplina oferece direção quando as emoções mudam de rumo.',
  'Os dias difíceis também contam quando você mantém o essencial.',
  'Existe dignidade em preparar com seriedade a vida que você deseja.',
  'A banca explora distrações; sua prática constrói atenção.',
  'Uma boa correção vale mais que muitas respostas apressadas.',
  'O esforço de compreender economiza o esforço de decorar sem sentido.',
  'Continue até que seu desempenho alcance a confiança que sua meta exige.',
  'A fé acompanha melhor quem também organiza a agenda.',
  'Você não precisa provar nada hoje; precisa aprender algo hoje.',
  'A memória é construída por encontros repetidos com o conteúdo.',
  'Cada retorno ao estudo enfraquece o hábito de adiar.',
  'Seja paciente com o aprendizado e firme com o compromisso.',
  'A conquista será sua; a construção também precisa ser.',
  'Quando o resultado demorar, deixe o método lembrar você da direção.',
  'Não despreze a sessão curta que mantém viva a continuidade.',
  'Seu nome na lista começa com sua presença na mesa de estudos.',
  'Estude com propósito suficiente para atravessar os dias sem espetáculo.',
  'Você chegou até aqui. Agora transforme intenção em mais um passo.'
];

export function getMotivationalMessage(previous) {
  const choices = MOTIVATIONAL_MESSAGES.filter(message => message !== previous);
  return choices[Math.floor(Math.random() * choices.length)];
}
